export const Currency = (value) => {
    return value?.toLocaleString('en-KE', {
        style: 'currency',
        currency: 'KES',
      })
}